import Header from './Header';
import { Outlet } from 'react-router';
import Footer from './Footer';
import { Box, Container } from '@mui/joy';

function Layout() {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
        }}>
            <Header />

            <Container disableGutters
                       component="main">

                <Outlet />

            </Container>

            <Box sx={{
                mt: 'auto',
            }}>
                <Footer />
            </Box>
        </Box>
    );
}

export default Layout;